// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_7652bfe2","outerContainer":"_1497ea13","secondaryToolbar":"_8e4980a2","doorHangerRight":"_27f9b319","toolbarContainer":"_6ad3d4c0","toolbarViewerMiddle":"_97447809","progressBar":"_40c09906","back-to-application":"_8b4d5783","durationWrapper":"d9c6c659","durationTitle":"_55346964","durationValue":"d2d965ba","status":"_923d9bca","btn":"_90ed900f","in-progress":"_61f0c842"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/AppointmentHeader/styles.styl
// module id = 4959
// module chunks = 39